import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import PublicPageLayout from "../components/PublicPageLayout";

export default function About() {
  return (
    <PublicPageLayout
      eyebrow="About Adyap"
      title="We got tired of vague career advice."
      subtitle="Adyap is an AI career coach that turns any job goal into a precise, day-by-day roadmap, and verifies that you actually did the work."
    >
      <h2>Why we built this</h2>
      <p>
        Adyap started with one founder's own job search: an IIT grad with an offer in hand who still had no clear
        answer to "what should I actually do today to get the role I want?" Human coaches were expensive and vague.
        Generic courses didn't map to any specific job. So the roadmap got built by hand, then automated.
      </p>

      <h2>What we do</h2>
      <p>
        Set a role and salary target, upload your resume, and Adyap reverse-engineers the skill gap between where
        you are and where you're going. From there it generates a day-by-day plan with real resources, time
        estimates, and milestones, plus a readiness score that reflects verified progress, not just checked boxes.
      </p>

      <h2>What's next</h2>
      <p>
        We're building toward a recruiter marketplace, where companies define the real stack and skills a role
        needs, and candidates train against actual requirements instead of guesswork. The goal is a readiness score
        recruiters can trust as much as candidates do.
      </p>

      <div className="mt-10 not-prose">
        <Link
          to="/signup"
          data-testid="about-cta"
          className="group inline-flex items-center gap-2 bg-primary hover:bg-primary/90 text-white px-6 py-3.5 rounded-full font-medium transition-colors glow-blue"
        >
          Build my roadmap <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
        </Link>
      </div>
    </PublicPageLayout>
  );
}
